import React, { useEffect, useState } from 'react'
import StartLogo from "../../assets/images/unitDetails/Flower.svg"
import { useNavigate } from 'react-router-dom';
import Specification from '../about/specification';
import VirtualTourBanner from '../virtualTour/virtualTourBanner';
const UnitDetailsSpecification = ({ data }) => {
    console.log('UnitDetailsSpecification', data[0].marketing);
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpenVirtual, setModalOpenVirtual] = useState(false);
    const [centerIndex, setCenterIndex] = useState(0);
    const carousles = [
        { name: data[0].marketing },
    ];

    let marketingType = '';
    switch (data[0].marketing) {
        case 'Designer Suite':
            marketingType = 'Designer Suite';
            break;
        case 'One Bedroom Townhouse':
            marketingType = 'Townhouse';
            break;
        case 'One Bedroom Penthouse':
            marketingType = '1BD Penthouses';
            break;
        case 'Two Bedroom Penthouse':
            marketingType = '2BD Penthouses';
            break;
        case 'Two Bedroom Sky Villa':
            marketingType = 'Sky Villas';
            break;
        default:
            marketingType = 'Designer Suite';
            break;
    }


    const imagesMap = {
        "Designer Suite": [
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds1.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds1.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds2.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds2.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds3.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds3.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds4.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds4.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds5.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds5.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds6.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds6.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds7.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds7.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds8.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds8.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds9.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds9.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds10.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/newds10.jpg" },


        ],

        "One Bedroom Penthouse": [
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph1.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph1.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph2.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph2.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph3.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph3.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph4.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph4.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph5.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph5.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph6.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph6.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph7.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph7.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph8.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph8.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph9.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph9.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph10.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph10.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph11.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/1bph11.jpg" },

        ],
        "Two Bedroom Penthouse": [
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p1.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p1.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p2.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p2.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p3.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p3.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p4.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p4.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p5.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p5.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p6.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p6.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p7.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p7.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p8.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p8.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p9.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p9.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p10.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p10.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p11.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/p11.jpg" },
        ],
        "One Bedroom Townhouse": [
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt1.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt1.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt2.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt2.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt3.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt3.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt4.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt4.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt5.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt5.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt6.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt6.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt7.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt7.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt8.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt8.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt9.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt9.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt10.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt10.jpg" },
            { original: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt11.jpg", thumbnail: "https://greendirectorydata.s3.us-east-2.amazonaws.com/bt11.jpg" },

        ],
        "Two Bedroom Sky Villa": [
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv1.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv1.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv2.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv2.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv3.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv3.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv4.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv4.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv5.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv5.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv6.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv6.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv7.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv7.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv8.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv8.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv9.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv9.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv10.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv10.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv11.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv11.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv12.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv12.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv13.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv13.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv14.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv14.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv15.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv15.jpg" },
            { original: "https://greendirectorydata.s3.amazonaws.com/2bsv16.jpg", thumbnail: "https://greendirectorydata.s3.amazonaws.com/2bsv16.jpg" },
        ],
    };


    const handleImageClick = (carouselName) => {
        const relatedImages = imagesMap[carouselName] || [];
        navigate('/gallery-internal', { state: { selectedCarousel: carouselName, images: relatedImages } });
    };

    let marketingTypeMapped = '';
    switch (data[0].marketing) {
        case 'Designer Suite':
            marketingTypeMapped = 'Designer_Suite';
            break;
        case 'One Bedroom Townhouse':
            marketingTypeMapped = '1B_Townhouse';
            break;
        case 'One Bedroom Penthouse':
            marketingTypeMapped = '1B_Penthouse';
            break;
        case 'Two Bedroom Penthouse':
            marketingTypeMapped = '2B_Penthouse';
            break;
        case 'Two Bedroom Sky Villa':
            marketingTypeMapped = '2B_Villa';
            break;
        default:
            marketingTypeMapped = 'Designer_Suite';
            break;
    }


    const virtualTourModal = [
        { image1: "https://www.renderatelier.com/360/GPP8/Designer_Suite/", },
        { image1: "https://www.renderatelier.com/360/GPP8/1B_Townhouse/", },
        { image1: "https://www.renderatelier.com/360/GPP8/1B_Penthouse/", },
        { image1: "https://www.renderatelier.com/360/GPP8/2B_Penthouse/", },
        { image1: "https://www.renderatelier.com/360/GPP8/2B_Villa/", },
    ]
    const selectedTourUrl = virtualTourModal.find(tour => tour.image1.includes(marketingTypeMapped))?.image1 || '';



    useEffect(() => {
        console.log("Modal Open:", modalOpen);
        console.log("Data:", data);
        console.log("Selected Type:", data?.[0]?.marketing);
    }, [modalOpen, data]);


    useEffect(() => {
        if (modalOpen || modalOpenVirtual) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [modalOpen, modalOpenVirtual]);


    return (
        <div className='unit-details-specification-main-bg-clr'>
            <div className='container'>
                {/* unit-details-specification-main-div */}
                <div className='unit-details-specification-main-div'>
                    {/* interior-specification-div */}
                    <div className='specification-div'
                        onClick={() => handleImageClick(carousles[centerIndex]?.name)}
                    >
                        <h3>Interior</h3>
                        <img src={StartLogo} alt='StartLogo' />
                    </div>
                    <div className='specification-div'
                        onClick={() => setModalOpenVirtual(true)}
                    // onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate("/virtual-tour"); }}
                    >
                        <h3>Virtual Tour</h3>
                        <img src={StartLogo} alt='StartLogo' />
                    </div>
                    <div className='specification-div' onClick={() => setModalOpen(true)}>
                        <h3>Specifications</h3>
                    </div>
                </div>
            </div>
            {modalOpen && (
                <div className='modal-div-specification'>
                    <button
                        className='modal-close-button'
                        onClick={() => setModalOpen(false)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M1 1L15 15" stroke="#000" stroke-width="2" stroke-linecap="round" />
                            <path d="M15 1L1 15" stroke="#000" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </button>
                    <Specification selectedType={marketingType} />
                </div>
            )}
            {modalOpenVirtual && (
                <div className='modal-div-virtual-tour'>
                    <div className='button-main-div'>
                        <button
                            className='modal-close-button'
                            onClick={() => setModalOpenVirtual(false)}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M1 1L15 15" stroke="#fff" stroke-width="2" stroke-linecap="round" />
                                <path d="M15 1L1 15" stroke="#fff" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                    <div className='virtual-tour-iframe'>
                        <iframe
                            src={selectedTourUrl}
                            title="Virtual Tour"
                            className='slider-image'
                            width="100%"
                            height="600"
                            frameBorder="0"
                            allowFullScreen
                        />
                    </div>
                </div>
            )}

        </div>
    )
}

export default UnitDetailsSpecification